import dynamic from 'next/dynamic';
import { AcrsFiltersProps } from './AcrsFilters.types';

export const AcrsFilters = dynamic<AcrsFiltersProps>(() => import('./AcrsFilters').then(module => module.AcrsFilters));
